<div class="bc-workitem-email-list">
  <div class="bc-sidenav-title-wrapper">
    <h2 class="bc-sidenav-title">
      <svg-icon icon="mail"></svg-icon>
      <span class="bc-sidenav-title-label" translate="{{ isHybrid ? 'bcWorkitemEmailList.dxTitleEmails' : 'bcWorkitemEmailList.titleEmails'}}"></span>
      <span [attr.data-automation-id]="'bc-email-counter'"> ({{ getEmailWorkitemCount() }})</span>
    </h2>
    <button class="btn btn-add"
            [attr.aria-label]="'bcWorkitemEmailList.newEmailTooltip' | translate"
            (click)="composeEmail()"
            [disabled]="!canComposeMoreEmails()"
            [attr.data-automation-id]="'email-compose-btn'">
      <svg-icon icon="plus"></svg-icon>

      <ng2-tooltip direction="right" text="{{ 'bcWorkitemEmailList.newEmailTooltip' | translate }}"></ng2-tooltip>
    </button>
  </div>

  <ul class="bc-workitem-titles-list bc-email-workitems">
    <li class="outer-item" [@taskItemAnimation]
        *ngIf="hasComposeEmailItem()" [attr.data-workitem-id]="'fake-workitem'">
      <div class="item theme-0 traversable-list-item"
           [attr.tabindex]="0"
           (keydown)="onComposeEmailKeydown($event)"
           (click)="selectComposeEmailItem()"
           [ngClass]="{ 'focus': isEmailComposeStateActive(), 'opened': isEmailComposeOpen() }">
        <div class="item-inner">
          <div class="visitor-avatar">
            <svg-icon icon="mail-open"></svg-icon>
          </div>

          <div class="sender-name" translate="bcWorkitemEmailList.composeTitle"></div>

          <div class="messages">
            <i class="glyphicon glyphicon-pencil"></i>
            <div class="shortcut">
              <svg-icon icon="enter-key"></svg-icon>
            </div>
          </div>
        </div>
      </div>
    </li>

    <ng-container *ngFor="let workitem of emailWorkItemList; trackBy: trackByWorkId">
      <li class="outer-item" [@taskItemAnimation]
          [attr.data-automation-id]="'bc-email-work-item-list-item'"
          [attr.data-workitem-id]="workitem.id"
          *ngIf="workitem.Name">

        <div class="item traversable-list-item"
             [attr.tabindex]="0"
             (keydown)="onWorkItemKeydown($event, workitem)"
             (click)="selectWorkItem(workitem)"
             [ngClass]="generateWorkitemClass(workitem)"
             [attr.data-automation-id]="'bc-email-traversable-item'">
          <div class="item-inner">
            <div class="visitor-avatar">
              <svg-icon icon="{{ getEmailStateIcon(workitem.NewItem) }}"
                        [attr.data-automation-id]="'bc-email-' + getEmailStateIcon(workitem.NewItem)"></svg-icon>
            </div>

            <workitem-simple-timer [initialTime]="workitem.Assigned"
                                   [showTimer]="true"></workitem-simple-timer>

            <div class="sender-name" [attr.data-automation-id]="'bc-email-item-sender'">{{ workitem.UserDisplayName }}</div>

            <div class="folder-wrapper">
              <div class="visitor-folder department-folder" [attr.data-automation-id]="'bc-email-item-folder'">
                <svg-icon icon="folder"></svg-icon>
                <span>{{ workitem.departmentFolder }}</span>
              </div>
            </div>

            <div class="messages">
              <div class="mail-subject" [attr.data-automation-id]="'bc-email-item-subject'">{{ workitem.Text }}</div>
              <div class="mail-text" [attr.data-automation-id]="'bc-email-item-text'">{{ workitem.FirstLine }}</div>
              <div class="shortcut">
                <svg-icon icon="enter-key"></svg-icon>
              </div>
            </div>
          </div>
        </div>
      </li>
      <li *ngIf="isSkeletonLoadingOn && !workitem.Name" class="outer-item">
        <app-skeleton-loader class="skeleton-item" appearance="circle" [mainItemCount]="2" [subItemCount]="2"></app-skeleton-loader>
      </li>
    </ng-container>
  </ul>
</div>
